import jquery from 'jquery'
window.jQuery = jquery
window.$ = jquery
//console.log('jquery js loaded')